import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  backdrop-filter: blur(1px);
  z-index: 99999;
`;

export const Fade = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  opacity: 0.2;
  background-color: #000000;
  z-index: 400;
`;

export const ModalWrapper = styled.div`
  box-sizing: border-box;
  width: 650px;
  max-height: 60vh;
  position: absolute;
  margin: 0 auto;
  z-index: 800;
  top: 50%; //25vh
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  box-shadow:
    0 4px 8px 0 rgba(15, 23, 40, 0.04),
    0 12px 18px 0 rgba(15, 23, 40, 0.12),
    0 0 10px 6px rgba(15, 23, 40, 0.04);
  padding: 16px;
  border-radius: 16px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.div`
  color: #06111e;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Footer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;

export const Line = styled.div<{ isWrap?: boolean }>`
  position: relative;
  display: flex;
  gap: 12px;
  flex-wrap: ${(props) => (props.isWrap ? 'wrap' : 'nowrap')};
`;

export const DividerLine = styled.div`
  display: flex;
  padding: 0 12px;
  align-items: center;
  align-self: stretch;
`;

export const Divider = styled.div`
  height: 1px;
  flex: 1 0 0;
  background-color: #e4e8ee;
`;

export const DividerText = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  color: #697180;
`;
